import { useTranslation } from 'react-i18next';
import ProductView from './Product';
import BasketView from './Basket';
import ProductCategoryView from './ProductCategoryView';
import { useEffect, useMemo, useState } from 'react';
import PriceAlertsConfiguration from '../../priceAlertsConfiguration/priceAlertsConfiguration';
import { PermissionEnum } from '../../../enums/PermissionEnum';
import { usePermissions } from '../../../hooks/usePermissions';
import CustomTabs from '../../../components/tabs/CustomTabs';
import BulkProductUploadView from './BulkProductUploadView';
import MainProductView from './MainProductView';

const ProductAndBasketManagement = () => {
  const { t } = useTranslation('productAndBasketManagement');
  const { hasPermission } = usePermissions();

  const [activeKey, setActiveKey] = useState('presentation');

  const tabs = useMemo(
    () =>
      [
        {
          key: 'productCategory',
          label: t('productCategory'),
          children: <ProductCategoryView />,
          isVisible: hasPermission([
            PermissionEnum.VIEW_PRODUCT_CATEGORIES,
            PermissionEnum.MANAGE_PRODUCT_CATEGORIES,
          ]),
          // forceRender: true,
        },
        {
          key: 'mainProduct',
          label: t('mainProduct'),
          children: <MainProductView />,
          isVisible: hasPermission(PermissionEnum.VIEW_PRODUCTS),
          // forceRender: true,
        },
        {
          key: 'basket',
          label: t('basket'),
          children: <BasketView />,
          isVisible: hasPermission(PermissionEnum.VIEW_BASKETS),
          // forceRender: true,
        },
        {
          key: 'presentation',
          label: t('presentation'),
          children: <ProductView />,
          isVisible: hasPermission(PermissionEnum.VIEW_PRESENTATION),
          // forceRender: true,
        },
        {
          key: 'priceAlertConfigurations',
          label: t('priceAlertConfigurations'),
          children: <PriceAlertsConfiguration />,
          isVisible: hasPermission([
            PermissionEnum.VIEW_PRODUCT_CATEGORIES,
            PermissionEnum.MANAGE_PRODUCT_CATEGORIES,
          ]),
          // forceRender: true,
        },
        {
          key: 'bulkProductUpload',
          label: t('bulkProductUpload'),
          children: <BulkProductUploadView />,
          isVisible: hasPermission([
            PermissionEnum.CREATE_PRODUCTS,
            PermissionEnum.UPDATE_PRODUCTS,
          ]),
          // forceRender: true,
        },
      ].filter((tab) => tab.isVisible),
    [hasPermission, t]
  );

  useEffect(() => {
    if (tabs.length > 0 && !tabs.some((tab) => tab.key === activeKey)) {
      setActiveKey(tabs[0].key);
    }
  }, [activeKey, tabs]);

  if (tabs?.length === 0) {
    return null;
  }

  return (
    <>
      <section className="mb-8 mt-6 w-full px-4 sm:mb-12 sm:mt-8 md:mb-16 md:mt-12 md:px-0">
        <h1 className="text-xl font-bold text-headings-font-color sm:text-2xl md:text-3xl lg:text-[36px]">
          {t('productBasketManagementTitle')}
        </h1>
        <p className="mt-2 text-sm font-medium text-font-color sm:text-base">
          {t('productBasketManagementSubTitle')}
        </p>
      </section>

      <section className="mb-6 mt-8 px-4 sm:mt-12 md:mt-16 md:px-0">
        <CustomTabs
          items={tabs}
          activeKey={activeKey}
          onChange={setActiveKey}
          className="responsive-kebab-tabs"
        />
      </section>
    </>
  );
};

export default ProductAndBasketManagement;
